import { render } from "./ArtiststbyGenero.vue?vue&type=template&id=2b7d3198"
import script from "./ArtiststbyGenero.vue?vue&type=script&lang=js"
export * from "./ArtiststbyGenero.vue?vue&type=script&lang=js"

import "./ArtiststbyGenero.vue?vue&type=style&index=0&id=2b7d3198&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__